// extracted by mini-css-extract-plugin
export default {"header":"HeaderDesktop_header__iPxZq","left":"HeaderDesktop_left__d0-RW","right":"HeaderDesktop_right__O66bl","logo":"HeaderDesktop_logo__-ACXk"};